import { Component } from '@angular/core';

@Component({
  selector: 'dispute',
  templateUrl: './dispute.component.html',
})
export class DisputeComponent {}
